var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_1",
    "data-name": 1,
    d: "M-2400-2208.5a13.5,13.5,0,0,1,13.5-13.5,13.5,13.5,0,0,1,13.5,13.5,13.5,13.5,0,0,1-13.5,13.5A13.5,13.5,0,0,1-2400-2208.5Zm2.7,0a10.8,10.8,0,0,0,10.8,10.8,10.8,10.8,0,0,0,10.8-10.8,10.8,10.8,0,0,0-10.8-10.8A10.8,10.8,0,0,0-2397.3-2208.5Zm9.45,6.75a1.354,1.354,0,0,1,1.35-1.35,1.354,1.354,0,0,1,1.35,1.35,1.354,1.354,0,0,1-1.35,1.35A1.354,1.354,0,0,1-2387.85-2201.75Zm0-4.051v-2.7a1.354,1.354,0,0,1,1.35-1.35,2.022,2.022,0,0,0,2.025-2.025,2.022,2.022,0,0,0-2.025-2.025,2.022,2.022,0,0,0-2.025,2.025,1.354,1.354,0,0,1-1.35,1.35,1.354,1.354,0,0,1-1.35-1.35,4.721,4.721,0,0,1,4.725-4.725,4.715,4.715,0,0,1,4.691,4.03,4.719,4.719,0,0,1-3.341,5.2v1.566a1.354,1.354,0,0,1-1.35,1.35A1.354,1.354,0,0,1-2387.85-2205.8Z",
    transform: "translate(2400 2222)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.334707ce58b77364aed6e47fb023c462.svg";
export { ForwardRef as ReactComponent };